import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border: solid 1px #e5e9e7;
  border-radius: 0 0 8px 8px;
  border-spacing: 0;
  background: #fff;
  border-collapse: collapse;
`;

export const TableTitle = styled.caption`
  padding: 18px 32px;
  color: rgb(62, 63, 65);
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  border: solid 1px #e5e9e7;
  border-radius: 8px 8px 0 0;
  border-spacing: 0;
`;

export const TableHeader = styled.th`
  padding: 12px 32px;
  background-color: #f4f5f7;
  color: #383c42;
  font-size: 14px;
  font-weight: normal;
  text-transform: uppercase;
  text-align: left;

  &:last-child {
    text-align: right;
  }
`;

export const TableCell = styled.td`
  padding: 18px 32px;
  border-bottom: solid 1px #e5e9e7;
  color: rgb(68, 68, 68);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  page-break-inside: avoid;

  &:last-child {
    text-align: right;
  }

  tr:last-child & {
    border-bottom: none;
  }
`;
